export enum ConsentType {
	Psd2 = 'PSD2',
	Budget = 'BUDGET',
	Pfm = 'PFM',
	FinanceDataPersonalOverview = 'FINANCE_DATA_PERSONAL_OVERVIEW',
	FinanceDataFinancialInsights = 'FINANCE_DATA_FINANCIAL_INSIGHTS',
	FinanceDataCreditAssessment = 'FINANCE_DATA_CREDIT_ASSESSMENT',
}
